import { render, staticRenderFns } from "./SingleAddressSchedule.vue?vue&type=template&id=060ab9d3&"
import script from "./SingleAddressSchedule.vue?vue&type=script&lang=js&"
export * from "./SingleAddressSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports